module.exports = __webpack_public_path__ + "img/ongle-incarne1.2cb13626.jpg";